import { useParams } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import { caseStudies } from '@/mocks/work';
import ProjectView from './components/ProjectView';

export default function ProjectDetail() {
  const { slug } = useParams();
  const index = caseStudies.findIndex((p) => p.slug === slug);
  if (index < 0) return <NotFound />;
  const project = caseStudies[index];
  const next = caseStudies[(index + 1) % caseStudies.length];
  // key forces a clean remount so scroll motion is scoped per project.
  return (
    <>
      <title>{`${project.title} | FORM & FEEL Work`}</title>
      <ProjectView key={project.slug} project={project} next={next} />
    </>
  );
}